import { m } from "#/paraglide/messages";

/**
 * App-wide shell rendered while route content loads.
 *
 * With `defaultSsr: 'data-only'` (src/start.ts), the root is the first client-only route,
 * so TanStack Start renders THIS component on the server as the fallback inside the root
 * shell (between <Header/> and <Footer/>). On a direct page load / hard refresh the user
 * sees this skeleton immediately; the real route component renders on the client after
 * hydration and replaces it.
 */
export function PageShell() {
  return (
    <main className="page-wrap px-4 pt-14 pb-8" aria-busy="true" aria-live="polite">
      <div className="island-shell rounded-[2rem] px-6 py-10 sm:px-10 sm:py-14">
        <div className="animate-pulse space-y-4">
          <div className="h-3 w-28 rounded-full bg-[var(--line)]" />
          <div className="h-10 w-2/3 rounded-2xl bg-[var(--line)]" />
          <div className="h-4 w-1/2 rounded-full bg-[var(--line)]" />
        </div>
      </div>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="island-shell h-28 animate-pulse rounded-2xl p-5">
            <div className="h-4 w-1/2 rounded-full bg-[var(--line)]" />
          </div>
        ))}
      </div>
      <span className="sr-only">{m["app.shell.loading"]()}</span>
    </main>
  );
}
